const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
if (!supabaseUrl) {
  throw new Error('Missing env var: VITE_SUPABASE_URL')
}

const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
if (!supabaseAnonKey) {
  throw new Error('Missing env var: VITE_SUPABASE_ANON_KEY')
}

const edgeFunctionsBaseUrl = import.meta.env.VITE_EDGE_FUNCTIONS_BASE_URL
if (!edgeFunctionsBaseUrl) {
  throw new Error('Missing env var: VITE_EDGE_FUNCTIONS_BASE_URL')
}

const mapboxToken = import.meta.env.VITE_MAPBOX_TOKEN
if (!mapboxToken) {
  throw new Error('Missing env var: VITE_MAPBOX_TOKEN')
}

const turnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? null

const DEFAULT_PUBLIC_BASE_URL = 'https://app.blindbookai.com'

const publicBaseUrl = (
  import.meta.env.VITE_PUBLIC_BASE_URL ?? DEFAULT_PUBLIC_BASE_URL
).replace(/\/+$/, '')

const appVersion = import.meta.env.VITE_APP_VERSION ?? 'dev'

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? ''

export const env = {
  supabaseUrl,
  supabaseAnonKey,
  edgeFunctionsBaseUrl,
  mapboxToken,
  turnstileSiteKey,
  publicBaseUrl,
  appVersion,
  stripePublishableKey,
} as const
